import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero, HeroVariant } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { Services } from './components/Services';
import { Reviews } from './components/Reviews';
import { QuotePath } from './components/QuotePath';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
const TITLE = 'Kosin’s Glass | Auto, Home, Shower & Commercial Glass';
const DESCRIPTION = 'Kosin’s Glass is a family-owned glass company serving Southeast Michigan since 2000: auto glass and windshields, residential window glass, custom glass shower doors and commercial glazing. Howell showroom, 517-545-7772.';
function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}
function readHeroVariant(): HeroVariant {
  if (typeof window === 'undefined') return 'van';
  const value = new URLSearchParams(window.location.search).get('hero');
  return value === 'storefront' ? 'storefront' : 'van';
}
export function App() {
  const [heroVariant, setHeroVariant] = useState<HeroVariant>(readHeroVariant);
  useEffect(() => {
    document.title = TITLE;
    setMeta('description', DESCRIPTION);
    setMeta('robots', 'noindex,nofollow');
  }, []);
  useEffect(() => {
    const syncVariant = () => setHeroVariant(readHeroVariant());
    window.addEventListener('popstate', syncVariant);
    return () => window.removeEventListener('popstate', syncVariant);
  }, []);
  return <div id="top" className="w-full bg-white" data-id="element-0" data-mp="3dii4aymltu1i">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded focus:bg-kosin-charcoal focus:px-4 focus:py-2 focus:text-white" data-id="element-1" data-mp="nuhged3fk1rn">
        Skip to main content
      </a>
      <Header data-id="element-2" data-mp="3uct4vo20uv2l" />
      <main id="main-content" tabIndex={-1} data-id="element-3" data-mp="3udawg7dqol46">
        <Hero variant={heroVariant} data-id="element-4" data-mp="3uc9inv5c9kir" />
        <TrustStrip data-id="element-5" data-mp="d4nv7fl6zi1v" />
        <Services data-id="element-6" data-mp="d57d4waue6fw" />
        <Reviews data-id="element-7" data-mp="d3cu5nj4soeg" />
        <QuotePath data-id="element-8" data-mp="d3wd97kipiu2" />
        <Faq data-id="element-9" data-mp="d2bj3j2481wq" />
        <FinalCta data-id="element-10" data-mp="85l0anyxes7m" />
      </main>
      <Footer data-id="element-11" data-mp="86mfn4mz60v5" />
    </div>;
}